<section class="flex flex-wrap justify-between items-center gap-3 mb-3">
    <h1 class="text-2xl font-bold text-gray-800">Productos</h1>
    <div class="flex items-center gap-2">
        @if(isRestaurant()){
        <a routerLink="/products-restaurant"
            class="px-3 py-2 text-sm font-bold text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
            Vista restaurante
        </a>
        }
        <add-button label="Nuevo Producto" (onClick)="openEditForm()"></add-button>
    </div>
</section>

<sau-table #sauTable [url]="url" contentList="list" contentTotal="count" pageParamName="page" contentTotal="total"
    [sizeInitialPage]="1" limitParamName="limit" [sizeBetweenPages]="1" [limit]="10" [headers]="headers"
    (deleteEvent)="openDeleteForm($event)" (editEvent)="openEditForm($event)"
    [customTemplates]="{ 'cost': costTmpl, 'variations_count': variationsTmpl }">

    <ng-template #costTmpl let-item="item">
        <span [centToEurDisplay]="item.cost"></span>
    </ng-template>

    <ng-template #variationsTmpl let-item="item">
        @if(item.variations_count){
        <span class="px-2 py-0.5 text-xs bg-purple-50 text-purple-800 border border-purple-200 rounded-full">
            {{ item.variations_count }} · stock {{ +(item.variations_stock || 0) }}
        </span>
        }
    </ng-template>

</sau-table>
